import React from 'react';
import { StyleSheet, View, Image, ScrollView } from 'react-native';

import color from '../../style/color';
import { useWindowSize } from '../../style/utils';

// This is the approved key visual exported directly from the referenced Figma frame
// (U74eT3aa36Huya7vGdcPFT, node 6399:13380). Keeping it as one responsive visual preserves the
// exact crop, logo variants, chip spacing and typography instead of approximating them in code.
const authKeyVisual = { uri: '/assets/images/backgrounds/auth-key-visual-fr.png' };

// Figma "Web-app auth — cashback activation revamp" (node 4965:9336): the key-visual panel is
// inset 40px from the top, right and bottom edges of a 1512x937 screen, with a 40px corner radius.
const PANEL_MARGIN = 40;
// Same frame: the form column is 384px wide and centred, and the auth form fields sit 16px apart.
export const FORM_WIDTH = 384;

// Shared shell for the sign-up and sign-in pages: the form centred in the left half, the key-visual
// panel on the right. Both pages use it so the two screens cannot drift apart again, and so the
// Joko logo lives in exactly one place — on the panel.
export default function AuthPageLayout({ children }: { children: React.ReactNode }) {
    const size = useWindowSize();
    return (
        <View style={[styles.container, { height: size.height }]}>
            {/* The form scrolls rather than being clipped: centring it vertically would otherwise
                hide the title on short windows, where a top-aligned form only lost its footer.
                `flexGrow` keeps it centred whenever there is room to spare. */}
            <ScrollView style={styles.containerForm} contentContainerStyle={styles.containerFormContent}>
                <View style={styles.containerContent}>{children}</View>
            </ScrollView>
            <Panel />
        </View>
    );
}

function Panel() {
    return (
        <View style={styles.containerPanelOuter}>
            <Image
                source={authKeyVisual}
                style={styles.imagePanel}
                resizeMode="contain"
                accessibilityLabel="Joko — Économisez sur plus de 10 000 marques"
            />
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        backgroundColor: color.white,
    },
    containerForm: {
        // Figma frame 4965:9336: 684px content + 40px gap + 748px visual + 40px right margin.
        width: '45.238095%',
        flexGrow: 0,
        flexShrink: 0,
    },
    // Centred whenever the window is tall enough, scrollable when it is not
    containerFormContent: {
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 40,
    },
    containerContent: {
        width: FORM_WIDTH,
    },
    containerPanelOuter: {
        flex: 1,
        paddingTop: PANEL_MARGIN,
        paddingLeft: PANEL_MARGIN,
        paddingRight: PANEL_MARGIN,
        paddingBottom: PANEL_MARGIN,
        alignItems: 'center',
        justifyContent: 'center',
    },
    // `contain` scales the whole approved visual together on short browser windows. This prevents
    // the bottom rows being cropped at 100% zoom while preserving the exact Figma proportions.
    imagePanel: {
        width: '100%',
        height: '100%',
        resizeMode: 'contain',
    },
});
